'use strict';
import React from 'react';

export default class SupportInfo extends React.Component {

    constructor(props) {
        super(props);
    }

    renderStaffSupportContact() {
        if(fhda.isActiveStaff) {
            return <p>
                Staff can contact the <a href="https://etshelp.fhda.edu">ETS Help Desk</a> for further assistance.
            </p>;
        } else {
            return <p>
                Staff can contact District Human Resources (<a href="http://hr.fhda.edu" target="_blank">http://hr.fhda.edu</a>) for further assistance.
            </p>;
        }
    }

    render() {
        return <div>
            <ul>
                <li>If you are a student, contact the Admissions and Records office for the college you are attending</li>
                <ul>
                    <li>Foothill College: (650) 949-7325 - <a href="mailto:webregfh@fhda.edu">webregfh@fhda.edu</a></li>
                    <li>De Anza College: (408) 864-5300 - <a href="mailto:webregda@fhda.edu">webregda@fhda.edu</a></li>
                </ul>
            </ul>

            {this.renderStaffSupportContact()}
        </div>;
    }

}


// WEBPACK FOOTER //
// ./src/react/SupportInfo.jsx